import {
  Button as ChakraButton,
  type ButtonProps as ChakraButtonProps
} from '@chakra-ui/react'
import { forwardRef } from 'react'

type ButtonVariant = 'primary' | 'secondary'

interface ButtonProps extends Omit<ChakraButtonProps, 'variant'> {
  variant?: ButtonVariant
}

const variantStyles: Record<ButtonVariant, ChakraButtonProps> = {
  primary: {
    bg: 'brand.600',
    color: 'white',
    _hover: { bg: 'brand.700' }
  },
  secondary: {
    bg: 'white',
    color: 'secondaryBlack',
    borderWidth: '1px',
    borderColor: 'gray.200',
    _hover: { bg: 'gray.50' }
  }
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'primary', children, ...props }, ref) => {
    const styles = variantStyles[variant]

    return (
      <ChakraButton
        ref={ref}
        h="44px"
        px={6}
        borderRadius="8px"
        fontWeight={500}
        fontSize="14px"
        {...styles}
        {...props}
        _focus={{ outline: 'none', boxShadow: 'none' }}
        _focusVisible={{ outline: 'none', boxShadow: 'none' }}
        _active={{ outline: 'none', boxShadow: 'none' }}
        _disabled={{
          bg: 'borderLight',
          color: 'gray.500'
        }}
      >
        {children}
      </ChakraButton>
    )
  }
)

Button.displayName = 'Button'

export default Button
